import { Inject, Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {mbeConfigService} from './mbe-config.service';
import {BfeeDetail, BfeeDetailAPI} from '../..';
import {BasicResponse} from '@auth-suite-services/services';

@Injectable({
  providedIn: 'root',
})
export class BfeeDetailService {
  private URL;
  headers: HttpHeaders;

  constructor(
    @Inject(mbeConfigService) private config,
    private httpClient: HttpClient
  ) {
    this.URL =
      config.REST_SERVER_HOST +
      config.REST_SERVER_url.find((restUrl) => restUrl.api === 'MBE').url;
    this.headers = new HttpHeaders().set('Content-Type', 'application/json');
  }

  getAllBFeeDetail(
    pageIndex: number,
    pageSize: number,
    sortActive: string,
    sort: string,
    bfsGid:number,
    bfsRno: number,

  ): Observable<BfeeDetailAPI> {
    console.log('PageIndex; PageSize; SortActive; Sort');
    console.log(pageIndex, pageSize, sortActive, sort, bfsGid, bfsRno);
    const headers = this.headers;
    const JSONObj = {
      finSetupObj: 1,
      bfsGid: bfsGid,
      bfsRno: bfsRno,
    };
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post<BfeeDetailAPI>(
      `${this.URL}/bfd/allbfdetail/${pageIndex}/${pageSize}/${
        sortActive ? sortActive : 'id'
      }/${sort ? sort : 'asc'}`,
      JSONObj,
      { headers }
    );
  }

  updateBFeeDetail(bfd: BfeeDetail): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Update bfd: ' + JSON.stringify(bfd));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/bfd/updatebfdetail`,
      bfd,
      { headers }
    );
  }

  createBFeeDetail(bfd: BfeeDetail): Observable<BasicResponse> {
    const headers = this.headers;
    console.log('Create bfd: ' + JSON.stringify(bfd));
    return this.httpClient.post<BasicResponse>(
      `${this.URL}/bfd/createbfdetail`,
      bfd,
      { headers }
    );
  }

  getBFeeDetail(id: number) {
    console.log('ID');
    console.log(id);
    const headers = this.headers;
    return this.httpClient.get<BfeeDetail>(
      `${this.URL}/bfd/getbfdetail/${id}`,
      { headers }
    );
  }
}

